<template>
    <section class="w-full">
        <div class="pda-default">
            <div class="t-headline5">
                {{$t('1672')}}
                <!-- 개인정보 입력 -->
            </div>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('1673')}}
                <!-- 개인정보를 확인 후 매장을 선택하세요. -->
            </div>
            <form @submit.prevent="next()" novalidate>
            <div class="mgt-35">
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" id="emailEl">
                    <i class="material-icons mdc-text-field__icon">
                        
                    </i>
                    <input type="email" class="mdc-text-field__input"
                        v-model="join.socialId"
                        readonly
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('1627')}}
                            <!-- 이메일 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                

                <div class="mdc-text-field mdc-text-field--outlined w-full mgt-14" id="firstNameEl">
                    <input type="text" class="mdc-text-field__input"
                        v-model="join.name.first"
                        readonly
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('1611')}}
                            <!-- 성 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                

                <div class="mdc-text-field mdc-text-field--outlined w-full mgt-14" id="lastNameEl">
                    <input type="text" class="mdc-text-field__input"
                        v-model="join.name.last"                            
                        readonly
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('1610')}}
                            <!-- 이름 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
            
            </div>

            <div class="mgt-50">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('1612')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelJoin()" type="button">
                    {{$t('1613')}}
                    <!-- 취소 -->
                </button>
                
            </div>
            </form>
        </div>

        
    </section>
    
</template>

<script>
/**
 * 회원가입 - 소셜 정보 확인 컴포넌트(sign up - check social information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            emailTextField: null,
            firstNameTextField: null,
            lastNameTextField: null,

            submitState: false,
            
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
    },

    created() {
        if (
                !this.join.responsibility || 
                !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || 
                !this.join.name.last || !this.join.socialId ||
                !this.join.socialLink.token || !this.join.socialLink.type

            ) {
             this.moveJoin2Intro()
        }
    },

    mounted() {
        this.setMaterialUi()
        
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['SET_STORE', 'INIT_JOIN_STORE']),

        setMaterialUi() {
            this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
            this.emailTextField.useNativeValidation = false
            
            this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
            this.firstNameTextField.useNativeValidation = false

            this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
            this.lastNameTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        

        // next
        next() {

            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.$router.push({name: 'Join2Store'})
                } else{
                    // this.focusFirstInvalidElement()
                    this.$snackOpen({
                        contents: this.$t('948'), //매장을 선택하세요.
                        btnDisplay: ''
                    }).then(() => {})
                }
            })
        },
    },
}
</script>